import * as React from "react";
import ListLoader from "../../../utils/loader/ListLoader";
import {IIsVisible} from "../../Checkout";
import KnownCustomer from "./KnownCustomer/KnownCustomer";
import GuestCustomer from "./GuestCustomer";
import RegisterCustomer from "./RegisterCustomer";
import OurStandards from "./OurStandards";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCartContext} from "../../../cart/CartContextProvider/CartContextProvider";
import {Payments} from "../../../lib/payments/PaymentController";
import {ICheckoutPutParams} from "@connox/typescript-library/types/checkout/requestHandlers/CheckoutRequestHandler";

const Login: React.FC<IIsVisible> = (props) => {
  const {checkout} = useCheckoutContext();
  const {setViewState, viewState} = useCartContext();

  if (!props.isVisible) {
    return null;
  }

  const onLoggedIn = () => {
    const toPut: ICheckoutPutParams = {};
    if (
      [Payments.GooglePay, Payments.PaypalExpressBraintree, Payments.ApplePay].includes(checkout.paymentId as Payments)
    ) {
      toPut.paymentId = null;
    }
    if (checkout.isGuest) {
      toPut.isGuest = false;
    }
    if (Object.keys(toPut).length) {
      void checkout.put(toPut);
    }
    setViewState({
      shippingErrors: viewState.shippingErrors,
      isRegistering: false,
      gPayData: undefined,
      paypalInfos: undefined,
    });
  };

  return (
    <div className={"text checkout-content"}>
      <React.Suspense fallback={<ListLoader />}>
        <div className="account-login login-block" style={{marginBottom: "0"}}>
          <KnownCustomer onLoggedIn={onLoggedIn} />
        </div>
        <div className="account-login" id="CheckoutRegistration">
          <RegisterCustomer />
        </div>
        <br className="clear" />
        <GuestCustomer />
        <OurStandards />
      </React.Suspense>
    </div>
  );
};

export default Login;
